interface UploadDirParams {
	collection: string;
	_id: string;
	type?: string;
	typeId?: string;
}
function getUploadDir({ collection, _id, type, typeId }: UploadDirParams): string {
	if (!collection) throw new Error("uploadDir: No collection");
	if (!_id) throw new Error("uploadDir: No _id");
	if (typeId && !type) throw new Error("uploadDir: typeId without type");
	return `${collection}/${_id}${type ? "/" + type : ""}${typeId ? "-" + typeId : ""}/`;
}

export { getUploadDir, type UploadDirParams };
